import { type IBaseEntity } from "types/apiResponse/apiResponse";

import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { type IModalConfiguration } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const UnifiedBillPayment = lazyLoadComponent(
    () => import("entity/unifiedBillPayment/UnifiedBillPayment/UnifiedBillPayment"),
);

export interface IBillPaymentRouteProps {
    /** Bills/POs to seed the dialog with — the current bills-list selection. */
    selectedPayables: IBaseEntity[];
    modalConfig: IModalConfiguration;
}

/**
 * Mounts the Unified Bill Payment dialog for the bills-list pay route (single or
 * mass, online or offline), deriving the mode and job from the URL
 * (`/BillMassPay/:isOnlinePayment/:selectedJobId?`) since the selection is held
 * in the list's component state rather than the URL.
 */
export const BillPaymentRoute: React.FunctionComponent<IBillPaymentRouteProps> = ({
    selectedPayables,
    modalConfig,
}) => (
    <RouteRelative
        path={routes.bill.massPay}
        render={(routeProps) => {
            const { isOnlinePayment, selectedJobId } = routeProps.match.params as {
                isOnlinePayment: string;
                selectedJobId: string;
            };
            return (
                <BTSuspense>
                    <UnifiedBillPayment
                        {...routeProps}
                        selectedPayables={selectedPayables}
                        isOnlinePayment={isOnlinePayment === "true"}
                        selectedJobId={parseInt(selectedJobId)}
                        modalConfig={modalConfig}
                    />
                </BTSuspense>
            );
        }}
    />
);
